import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Container,
  InputGroup,
  FormInput,
  InputGroupAddon,
  Button,
} from "shards-react";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from "react-i18next";
import useCurrentUser from "shared/hook/useCurrentUser";

const axios = require("axios").default;

const StyledContainer = styled(Container)`
  padding: 40px 0;
`;

const Link = styled.a``;
const StyledButton = styled(Button)`
  border-radius: 8px !important;
  margin-left: 20px;
`;
const IndicatorsContent = styled.div`
  padding: 30px 0;
  cursor: pointer;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
`;

const StyledIndicatorsList = styled.a`
  color: #000;
  padding: 4px 30px;
  border-radius: 8px;
  position: relative;
  i {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 10px;
    -moz-border-radius: 7.5px;
    -webkit-border-radius: 7.5px;
    border-radius: 7.5px;
    position: absolute;
    background-color: #1968bc;
    left: 10px;
    top: 10px;
  }
  :hover {
    color: #000 !important;
  }
`;

const SearchIndicators = () => {
  const { curruntUser } = useCurrentUser();
  const [indicatorsName, setIndicatorsName] = useState("");
  const [indicatorsList, setIndicatorsList] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const onSearchIndicators = () => {
    if (indicatorsName) {
      setLoading(true);

      var data = JSON.stringify({
        params: {
          indicatorsDatasetSettingName_TH_EN: indicatorsName,
          // "up.upId": curruntUser ? curruntUser.user.userId :null
        },
        show: 1000,
        page: 1,
        orderBy: "indicatorsAgencySettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/indicatorsDataset`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setLoading(false);
          setIndicatorsList(response.data);
          // setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  useEffect(() => {
    if (indicatorsName === "") {
      setIndicatorsList(null);
    }
  });
  return (
    <StyledContainer>
      <Row>
        <Col className="text-center">
          <h5 className="bold text-balck mb-4">
            - {t("common:homePage.SearchingKPI")} -
          </h5>
        </Col>
      </Row>
      <Row>
        <Col sm={{ size: 4, order: 4, offset: 4 }}>
          <InputGroup>
            <FormInput
              placeholder={`${t("common:homePage.Searching")}`}
              value={indicatorsName}
              onChange={(e) => setIndicatorsName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearchIndicators();
                }
              }}
            />
            <InputGroupAddon type="append">
              <StyledButton
                className="btn-success"
                onClick={onSearchIndicators}
              >
                {t("common:homePage.Search")}
              </StyledButton>
            </InputGroupAddon>
          </InputGroup>
        </Col>
      </Row>
      {/* {indicatorsName && indicatorsList &&( */}
      <Row>
        <Col sm={{ size: 6, order: 3, offset: 3 }}>
          <IndicatorsContent>
            {loading ? (
              <div>Loading...</div>
            ) : (
              indicatorsList &&
              indicatorsList.data.length > 0 &&
              indicatorsList.data.map((item, key) => {
                if (key < 4) {
                  return (
                    <StyledIndicatorsList
                      key={key}
                      href={`/indicators/detail/${item.id}`}
                      target="_blank"
                    >
                      <i></i>
                      {i18n.language === "th"
                        ? item.indicatorsDatasetSettingName
                        : item.indicatorsDatasetSettingNameEN || item.indicatorsDatasetSettingName}
                    </StyledIndicatorsList>
                  );
                }
              })
            )}
          </IndicatorsContent>
        </Col>
        <Col sm={{ size: 6, order: 3, offset: 3 }} className="text-center">
          {indicatorsList && indicatorsList.data.length > 0 && (
            <Link href="/indicators-list">{`+ ${t("common:homePage.KPIMore")} >>`}</Link>
          )}

          {indicatorsName &&
            indicatorsList &&
            indicatorsList.data.length === 0 && (
              <div className="text-center">--- {t("common:homePage.NoDataKPI")} ---</div>
            )}
        </Col>
      </Row>
      {/* )} */}
    </StyledContainer>
  );
};
export default SearchIndicators;
